import React from "react";
import {FormattedMessage} from "react-intl";
import {findMobileOperatingSystemAndGetLink} from "../../util/common";
import {PATH} from "../../routes/routes.js";
import * as StorageService from "../../services/StorageService";
import {LOCALSTORAGE_ITEMS} from "../../util/Constants";
import {useNavigate} from "react-router";

function ThankYouActionsBar(props) {
    const navigateTo = useNavigate();
    const clearOrderIdAndRedirect = () => {
        StorageService.removeItem(LOCALSTORAGE_ITEMS.ORDER_ID);
        navigateTo(PATH.ALL_PRODUCTS);
    }

    return (
        <div className={props.isVisible ? "actionsbar static thank-you-actions-bar show" : "static actionsbar"}>
            <div className="banner campaigns-banner">
                {props.showDownloadApp &&<div className="row">
                    <p><FormattedMessage id="GetAnEvenBetterOrdering"/></p>
                    <a target="_blank" href={findMobileOperatingSystemAndGetLink()} className="btn btn-special"><FormattedMessage id="GetApp"/></a>
                </div>}
            </div>
            <div className="row buttons-row">
                <button className={props.btnClassName} onClick={() => clearOrderIdAndRedirect()}>
                    {props.btnName}
                </button>
            </div>
        </div>


    );
}

export default ThankYouActionsBar;
